module.exports = __webpack_public_path__ + "static/media/kp.f08daf33.svg";